import { defaultErrorToTerm } from '../../../otherBusinessLogic/defaultErrorToTerm';

/**
 * Translates rollback error to a term ready to be translated.
 */
export function errorToTerm(exception: unknown): string {
  return defaultErrorToTerm(exception) ?? 'rollback_unknown_error';
}
